angular.module('static-categories', [])
    .service('staticCategories', staticCategories);

staticCategories.$inject = [];

function staticCategories() {
    var staticCategories = {
            cats: [
                { categoryId: 33, name: 'PAYMENTS.MOBILE'},
                { categoryId: 44, name: 'PAYMENTS.HOSTING'},
                { categoryId: 39, name: 'PAYMENTS.WEBMONEY'},
                { categoryId: 34, name: 'PAYMENTS.INTERNET'},
                { categoryId: 40, name: 'PAYMENTS.GAMES'},
                { categoryId: 37, name: 'PAYMENTS.COMMUNAL'},
                { categoryId: 38, name: 'PAYMENTS.CREDIT'},
                // { categoryId: 32, name: 'PAYMENTS.RECVIZ'}, category 32 moved into category other
                { categoryId: 'favorites', name: 'PAYMENTS.FAVORITE'},
                { categoryId: 'other', name: 'PAYMENTS.OTHER'},
                { categoryId: 46, name: 'PAYMENTS.TICKETS'}
            ],
            catsIds: []
    };
    /*only ids array*/
        staticCategories.cats.map(function (service) {
            staticCategories.catsIds.push(service.categoryId);
            return service;
        });
    /*end only ids array*/

    return staticCategories;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/static-categories/services/static-categories.js
 ** module id = 115
 ** module chunks = 1
 **/